<template>
  <BaseModal v-on="$listeners">
    <BaseText v-html="rulesText" tag="div" />
    <template #actions>
      <BaseButton
        :text="$t('actions.understand')"
        size="s"
        class="modal__action"
        @click="$emit('close')"
      />
    </template>
  </BaseModal>
</template>

<script>
import rules from '@/locales/rules';

import BaseModal from '@/components/BaseModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'ModalRules',
  components: {
    BaseModal,
    BaseButton,
    BaseText,
  },
  computed: {
    rulesText() {
      const { locale } = this.$i18n;
      return rules[locale] || '';
    },
  },
};
</script>
